import { useState } from 'react';

import { DownIcon } from '../icons/DownIcon';

export type DropdownOption<T = number> = {
  value: T;
  label?: string;
};
export type DropdownProps<T = number> = {
  onChange?: (selectedOption: DropdownOption<T>) => void;
  options: DropdownOption[];
  value: T;
};

export const Dropdown = ({ onChange, options, value }: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find(option => option.value === value);

  const toggling = () => {
    setIsOpen(!isOpen);
  };

  const onOptionClicked = (selectedOption: DropdownOption) => () => {
    if (onChange) {
      onChange(selectedOption);
    }
    setIsOpen(false);
  };

  return (
    <div className={`cursor-default my-0 mx-auto relative w-full`}>
      <div className={`cursor-pointer flex items-center justify-end p-1`} onClick={toggling}>
        <div className={`text-right select-none`}>{`${selectedOption?.label || selectedOption?.value}`}</div>
        <div className={`h-6 w-6 p-1 transform ${isOpen ? 'rotate-180' : ''}`}>
          <DownIcon />
        </div>
      </div>
      {isOpen && (
        <div className={`absolute w-full z-50`}>
          <ul className={`shadow-md bg-white m-0 p-0`}>
            {options.map(option => (
              <li
                className="icon-library--size-dropdown--option cursor-pointer list-none opacity-50 px-2 py-2 text-right text-xs leading-none"
                onClick={onOptionClicked(option)}
                key={Math.random()}
              >
                {`${option.label || option.value}`}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
